<h1><a href="/admin-home">Admin</a> - Price Tiers</h1>

<section>
  <p>{{loading}}</p>
  <div class="container">
    <div class="left">
      <h3>Dealer Tier USA Pricing</h3>
      <table class="data">
        <thead>
          <tr>
            <td>Min</td>
            <td>USA</td>
            <!-- <td>CAN</td> -->
            <td></td>
          </tr>
        </thead>
        <tbody>
          @for (priceTier of priceTiers; track priceTier; let idx = $index) {
          <tr>
            <td>{{priceTier.qty}}</td>
            <td>$ <input type="number" [(ngModel)]="priceTiers[idx].price"></td>
            <!-- <td>$ <input type="number" [(ngModel)]="priceTiers[idx].price_canadian_dollar"></td> -->
            <td><button (click)="updateQty(idx, priceTier.type)">Update Tier Min {{priceTier.qty}}</button></td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    
    <div class="right">
      <h3>Dealer Tier Canada Pricing</h3>
      <table class="data">
        <thead>
          <tr>
            <td>Min</td>
            <td>USA</td>
            <td>CAN</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          @for (canadaPriceTier of canadaPriceTiers; track canadaPriceTier; let idx = $index) {
          <tr>
            <td>{{canadaPriceTier.qty}}</td>
            <td>$ <input type="number" [(ngModel)]="canadaPriceTiers[idx].price"></td>
            <td>$ <input type="number" [(ngModel)]="canadaPriceTiers[idx].price_canadian_dollar"></td>
            <td><button (click)="updateQty(idx, canadaPriceTier.type)">Update Tier Min {{canadaPriceTier.qty}}</button></td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <h3>Fleet Tier Pricing</h3>
  <table class="data">
    <thead>
      <tr>
        <td>Min</td>
        <td>USA</td>
        <td>CAN</td>
        <td></td>
      </tr>
    </thead>
    <tbody>
      @for (fleetprice of fleetPriceTiers; track fleetprice; let indx = $index) {
      <tr>
        <td>{{fleetprice.qty}}</td>
        <td>$ <input type="number" [(ngModel)]="fleetPriceTiers[indx].price"></td>
        <td>$ <input type="number" [(ngModel)]="fleetPriceTiers[indx].price_canadian_dollar"></td>
        <td><button (click)="updateQty(indx, fleetprice.type)">Update Tier Min {{fleetprice.qty}}</button></td>
      </tr>
      }
    </tbody>
  </table>
</section>